var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeviceSettingsShockStrong = function SvgDeviceSettingsShockStrong(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg3787",
    width: 36,
    height: 36,
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -1016.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3806",
    fill: "currentColor",
    d: "m5.133 1042.5 12.041-12.144 2.111-.018-5.496-5.874 1.702-1.734c1.125-.25 4.51-.336 5.448-.024l9.596 8.953-4.543 4.761-4.994-4.594-.02 2.374-11.857 12.648c-1.136-.252-3.799-3.054-3.988-4.349z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeviceSettingsShockStrong);
export default ForwardRef;